import React from 'react';
import { Paper, Typography, Box, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function HelpScreen({ open, onClose, description, hasMedleys }) {
  if (!open) return null;

  return (
    <Paper
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1800,
        backgroundColor: 'rgba(0, 0, 0, .95)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'auto'
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          color: 'white'
        }}
      >
        <CloseIcon />
      </IconButton>
      
      <Box sx={{ maxWidth: 900, mx: 'auto', px: '2rem', color: 'white', textAlign: 'left' }}>
        <Typography variant="h4" sx={{ mb: '2rem'}}>
          SenseMap is an interactive network of conversations:
        </Typography>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem'}}>
            <img src="/conversation_bubble.svg" alt='A conversation bubble containing many highlight nodes.' style={{ width: '80px' }}></img>
            <Typography variant="h6">Each bubble of nodes represents a recorded conversation (a collection of highlights).</Typography>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem'}}>
            <img src="/node.svg" alt='A single highlight node.' style={{ width: '24px', padding: '28px'}}></img>
            <div>
            <Typography variant="h6" sx={{ mb: 1}}>Each colorful node represents a highlight (something someone said).</Typography>
            <Typography  variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>Click any node to hear its highlight.</Typography>
            <Typography variant="h6">A node gets its color from its themes: similar themes have similar colors, and a node's color represents its mix of themes.</Typography>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem'}}>
            <img src="/connection.svg" alt='A line connecting two highlight nodes.' style={{ width: '80px' }}></img>
            <Typography variant="h6">A connecting line between two nodes means they share at least one theme.</Typography>
          </div>
        {hasMedleys ?( 
        <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
          Medleys and Themes
        </Typography>
        ) : ( <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
          Themes
        </Typography> )}
        {hasMedleys && ( 
        <Typography variant="h6" sx={{ mb: 2 }}>
        • Choose a <span style={{ fontWeight: 'bold'}}>Medley</span> to listen to a curated set of highlights that tell a story.
        </Typography>
        )}
        <Typography variant="h6" sx={{ mb: 2 }}>
        • Select a <span style={{ fontWeight: 'bold'}}>Theme</span> to filter the network for highlights related to that theme.
        </Typography>
      </Box>
      <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            mt: 4,
            backgroundColor: 'transparent',
            color: 'white',
            borderColor: 'white',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderColor: 'white',
            },
            fontSize: '1.2rem',
            textTransform: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          Let's Explore <span style={{ fontSize: '1.3rem' }}>→</span>
        </Button>
    </Paper>
  );
}

export default HelpScreen; 